export default __webpack_public_path__ + "static/media/colchester.463b6a1e.jpg";